<div class="navbar bg-base-100 relative flex py-0">
  <div class="navbar-start flex-1">
    <ul class="menu menu-horizontal py-0 px-1">
      <li class="flex gap-1 flex-row" appRequireSetup>
        <button
          class="btn btn-sm btn-neutral btn-outline"
          [class.here]="activeGamePlayView() === 'world'"
          tp="World [1]"
          (click)="changeGamePlayView('world')"
          appSfx="ui-click"
          [sfxOffset]="0"
          [sfxTrigger]="['click', 'hover']"
          [hotkeys]="'1'"
          (hotkey)="hotkeyMatches($event, '1') && changeGamePlayView('world')"
          isGlobal
          appTutorialTarget="nav-world"
        >
          World
        </button>

        <button
          class="btn btn-sm btn-neutral btn-outline"
          [class.here]="activeGamePlayView() === 'kingdom'"
          tp="Kingdom [2]"
          (click)="setKingdomPlayView()"
          appSfx="ui-click"
          [sfxOffset]="1"
          [sfxTrigger]="['click', 'hover']"
          [hotkeys]="'2'"
          (hotkey)="hotkeyMatches($event, '2') && setKingdomPlayView()"
          isGlobal
          appTutorialTarget="nav-kingdom"
        >
          Kingdom
        </button>

        <button
          class="btn btn-sm btn-neutral btn-outline"
          [class.here]="activeGamePlayView() === 'heroes'"
          tp="Heroes [3]"
          (click)="setHeroesPlayView()"
          appSfx="ui-click"
          [sfxOffset]="3"
          [sfxTrigger]="['click', 'hover']"
          [hotkeys]="'3'"
          (hotkey)="hotkeyMatches($event, '3') && setHeroesPlayView()"
          isGlobal
          appTutorialTarget="nav-heroes"
        >
          Heroes
        </button>

        <button
          class="btn btn-sm btn-neutral btn-outline"
          [class.here]="activeGamePlayView() === 'adventurelog'"
          tp="Adventure Log [4]"
          (click)="changeGamePlayView('adventurelog')"
          appSfx="ui-click"
          [sfxOffset]="2"
          [sfxTrigger]="['click', 'hover']"
          [hotkeys]="'4'"
          (hotkey)="
            hotkeyMatches($event, '4') && changeGamePlayView('adventurelog')
          "
          isGlobal
          appTutorialTarget="nav-adventurelog"
        >
          Adventure Log
        </button>

        <button
          class="btn btn-sm btn-neutral btn-outline"
          [class.here]="activeGamePlayView() === 'decree'"
          [tp]="decreeTooltip"
          (click)="changeGamePlayView('decree')"
          (contextmenu)="toggleAutoMode()"
          appSfx="ui-click"
          [sfxOffset]="4"
          [sfxTrigger]="['click', 'hover']"
          [hotkeys]="'5'"
          (hotkey)="hotkeyMatches($event, '5') && changeGamePlayView('decree')"
          isGlobal
          [appHideUntilLevel]="5"
          appTutorialTarget="nav-decree"
        >
          <input
            type="checkbox"
            [checked]="autoModeEnabled()"
            class="checkbox checkbox-xs"
          />

          Decree
        </button>

        <ng-template #decreeTooltip>
          @let activeId = activeClauseId();
          <div class="flex flex-col gap-2 p-2 max-w-[400px]">
            <span class="font-semibold">Decree [5]</span>
            @for (clause of enabledClauses(); track clause.id) {
              <span
                class="text-xs"
                [class.text-success]="clause.id === activeId"
                [class.font-semibold]="clause.id === activeId"
              >
                {{ $index + 1 }}. {{ clauseSummary(clause) }}
              </span>
            } @empty {
              <span class="text-xs text-lighter">No active clauses.</span>
            }
          </div>
        </ng-template>
      </li>
    </ul>
  </div>

  <app-button-update class="mx-1"></app-button-update>

  <div class="navbar-end">
    <ul class="menu menu-horizontal px-1 flex gap-1">
      @for (panel of panelConfigs; track $index) {
        <li class="action-button" appRequireSetup>
          <button
            class="btn btn-sm btn-neutral"
            [tp]="panel.name + ' [' + panel.hotkey + ']'"
            (click)="panel.clickCb()"
            [hotkeys]="panel.hotkey"
            (hotkey)="hotkeyMatches($event, panel.hotkey) && panel.clickCb()"
            isGlobal
            appSfx="ui-click"
            [sfxOffset]="$index"
            [sfxTrigger]="['click', 'hover']"
          >
            <app-icon [name]="panel.icon" size="nav"></app-icon>
          </button>
        </li>
      }

      @if (currentTownEntry()) {
        <button
          class="btn btn-sm btn-neutral"
          appButtonGlow
          [tp]="currentTownName() + ' [T]'"
          (click)="openCurrentTown()"
          appSfx="ui-click"
          [sfxOffset]="5"
          [sfxTrigger]="['click', 'hover']"
          [hotkeys]="'T'"
          (hotkey)="hotkeyMatches($event, 'T') && openCurrentTown()"
          isGlobal
        >
          <app-icon name="gameVillage" size="nav"></app-icon>
        </button>
      }

      @if (showCaravanTradeButton()) {
        <li class="action-button" appRequireSetup>
          <button
            class="btn btn-sm btn-neutral"
            appButtonGlow
            tp="Trade with the Caravan [T]"
            (click)="openCaravanTrade()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
            [hotkeys]="'t'"
            [hotkeysOptions]="noPreventDefault"
            (hotkey)="hotkeyMatches($event, 't') && openCaravanTrade()"
            isGlobal
          >
            <app-icon name="gameSwapBag" size="nav"></app-icon>
          </button>
        </li>
      }

      @if (currentTrainerEntry()) {
        <li class="action-button" appRequireSetup>
          <button
            class="btn btn-sm btn-neutral"
            appButtonGlow
            tp="Visit the Trainer [T]"
            (click)="openCurrentTrainer()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
            [hotkeys]="'t'"
            [hotkeysOptions]="noPreventDefault"
            (hotkey)="hotkeyMatches($event, 't') && openCurrentTrainer()"
            isGlobal
          >
            <app-icon name="gameClassicalKnowledge" size="nav"></app-icon>
          </button>
        </li>
      }

      @if (showRecenterButton()) {
        <li class="action-button" appRequireSetup>
          <button
            class="btn btn-sm btn-neutral"
            tp="Recenter on Hero [R]"
            (click)="recenterCamera()"
            appSfx="ui-click"
            [sfxOffset]="panelConfigs.length + 3"
            [sfxTrigger]="['click', 'hover']"
            [hotkeys]="'r'"
            [hotkeysOptions]="noPreventDefault"
            (hotkey)="hotkeyMatches($event, 'r') && recenterCamera()"
            isGlobal
          >
            <app-icon name="tablerFocus" size="nav"></app-icon>
          </button>
        </li>
      }

      @if (isFelDefeated()) {
        <li class="action-button" appRequireSetup>
          <app-button-run-end class="p-0 gap-0" [compact]="true" />
        </li>
      }

      <li class="action-button" appRequireSetup>
        <button
          class="btn btn-sm btn-neutral"
          [tp]="isPaused() ? 'Resume Game [SPACE]' : 'Pause Game [SPACE]'"
          (click)="togglePause()"
          appSfx="ui-click"
          [sfxOffset]="panelConfigs.length + 2"
          [sfxTrigger]="['click', 'hover']"
          [hotkeys]="'SPACE'"
          (hotkey)="hotkeyMatches($event, 'SPACE') && togglePause()"
          isGlobal
        >
          <app-icon
            [name]="isPaused() ? 'gamePlayButton' : 'gamePauseButton'"
            size="nav"
          ></app-icon>
        </button>
      </li>

      <li class="action-button" appRequireNotSetup>
        <button
          type="button"
          class="btn btn-sm btn-neutral btn-outline"
          [swal]="leaveSwal"
          [tp]="'Go Back [Q]'"
          appSfx="ui-error"
          [sfxOffset]="panelConfigs.length + 1"
          [sfxTrigger]="['click', 'hover']"
          [hotkeys]="'q'"
          (hotkey)="hotkeyMatches($event, 'q') && leaveSwal.fire()"
          isGlobal
        >
          <app-icon name="gameExitDoor" size="nav"></app-icon>
        </button>
      </li>

      <li class="action-button" appRequireSetup>
        <button
          class="btn btn-sm btn-neutral"
          [tp]="'Open Menu [ESC]'"
          (click)="closeAllMenus()"
          appSfx="ui-click"
          [sfxOffset]="panelConfigs.length + 2"
          [sfxTrigger]="['click', 'hover']"
          [hotkeys]="'ESCAPE'"
          (hotkey)="hotkeyMatches($event, 'ESCAPE') && closeAllMenus()"
          isGlobal
        >
          <app-icon [name]="'tablerSettings'" size="nav"></app-icon>
        </button>
      </li>
    </ul>
  </div>
</div>

<div class="absolute top-[40px] left-1/2 -translate-x-1/2 z-30">
  <app-bar-resource />
</div>

<swal
  #leaveSwal
  title="Go back to main menu?"
  icon="question"
  confirmButtonText="Yes, go back"
  cancelButtonText="No, stay here"
  (confirm)="goToHome()"
></swal>

<app-modal
  modalId="pause-menu"
  [widthClass]="'max-w-[300px]'"
  [closeOnBackdropClick]="true"
  (modalClose)="closePauseMenu()"
>
  <span title>Game Paused</span>

  <div body class="flex flex-col gap-2">
    <button
      type="button"
      class="btn btn-primary"
      (click)="closePauseMenu()"
      appSfx="ui-click"
      [sfxOffset]="0"
      [sfxTrigger]="['click', 'hover']"
    >
      Resume
    </button>

    <app-panel-debug-buttons></app-panel-debug-buttons>

    <app-button-settings></app-button-settings>

    <button
      type="button"
      class="btn btn-neutral btn-outline"
      [swal]="leaveSwal"
      appSfx="ui-error"
      [sfxOffset]="2"
      [sfxTrigger]="['click', 'hover']"
    >
      Quit to Main Menu
    </button>

    <app-button-quit></app-button-quit>
  </div>
</app-modal>

<app-modal-caravan-trade></app-modal-caravan-trade>
<app-modal-trainer-visit></app-modal-trainer-visit>
<app-modal-exchange-node></app-modal-exchange-node>
<app-modal-outpost-teleport></app-modal-outpost-teleport>
<app-modal-tasks></app-modal-tasks>

<app-modal-town-material-sale></app-modal-town-material-sale>
